<template>
  <div class="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat relative" :style="{ backgroundImage: `url('/images/login_bg.webp')` }">
    <div class="absolute inset-0 bg-black/40"></div>

    <div class="text-center p-8 relative z-10">
      <div class="mb-6 drop-shadow-[0_2px_8px_rgba(255,255,255,0.8)]">
        <i v-if="error.statusCode === 404" class="pi pi-search text-7xl text-white"></i>
        <i v-else-if="error.statusCode === 401 || error.statusCode === 403" class="pi pi-lock text-7xl text-white"></i>
        <i v-else class="pi pi-exclamation-triangle text-7xl text-white"></i>
      </div>

      <h1 class="text-8xl font-bold mb-4 text-white drop-shadow-[0_4px_12px_rgba(255,255,255,0.6)]">
        {{ error.statusCode }}
      </h1>

      <h2 class="text-3xl font-semibold mb-3 text-white drop-shadow-[0_2px_8px_rgba(255,255,255,0.5)]">
        {{ errorTitle }}
      </h2>

      <div class="flex mt-6 gap-4 justify-center">
        <button
          v-if="error.statusCode === 401"
          @click="redirectToLogin"
          class="px-6 py-3 bg-white/90 text-gray-900 font-semibold rounded-lg hover:bg-white transition-colors shadow-lg"
        >
          {{ t('errorPage.login') }}
        </button>
        <button
          v-else
          @click="handleError"
          class="px-6 py-3 bg-white/90 text-gray-900 font-semibold rounded-lg hover:bg-white transition-colors shadow-lg"
        >
          {{ t('errorPage.home') }}
        </button>

        <button
          @click="goBack"
          class="px-6 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 transition-colors backdrop-blur-sm"
        >
          {{ t('errorPage.back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object
})

const { t } = useI18n()

const errorTitle = computed(() => {
  const code = props.error?.statusCode

  switch (code) {
    case 404:
      return t('errorPage.notFound')
    case 401:
      return t('errorPage.unauthorized')
    case 403:
      return t('errorPage.forbidden')
    case 500:
      return t('errorPage.serverError')
    case 503:
      return t('errorPage.serviceUnavailable')
    default:
      return t('errorPage.unexpected')
  }
})

const handleError = () => {
  clearError({ redirect: '/' })
}

const redirectToLogin = () => {
  clearError({ redirect: '/login' })
}

const goBack = () => {
  if (import.meta.client && window.history.length > 1) {
    window.history.back()
  } else {
    clearError({ redirect: '/' })
  }
}
</script>
